import { region as getRegion } from '@/utils/utils'
import accounting from 'accounting-js'
import { moneyFormatRules } from '@/utils/moneyFormatRules'

const region = getRegion()

export function formatMoney(value, needHandle = false) {
  if (!value) return value
  // 由于服务端做了限制只保留了一位小数，因此前端做两位小数补全
  if (region === 'in' && (value + '').indexOf('.') === -1) {
    value = (value * 1).toFixed(2)
  }
  let precision
  if (needHandle === true) {
    value = (value * 100) / 100
    precision =
      (value.toString().split('.')[1] &&
        value.toString().split('.')[1].length) ||
      0
  }

  const { decimal, separator, decimalPlaces } = moneyFormatRules || {}
  return accounting.formatMoney(value, {
    symbol: '',
    decimal: decimal || ',',
    thousand: separator || '.',
    precision: needHandle === true ? precision : decimalPlaces || 0,
  })
}
